import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class AppSettings {
  public static BASE_URL = environment.basePath;
  public static TENANT = environment.tenant;
  public static SUPPORTED_COUNTRY = environment.supportedCountry;
  public static VERSION = environment.version;
  public static LOCATION_LIST = 'locationList'
  public static VEHICLE_TYPE_DATA = "vehicleTypeData"
  public static TENANT_INFO = 'tenantInfo';
  public static PASSENGER_LIST_TYPE = 'passengerTypeList';
  public static FRONTEND_BASE_URL = 'front_end_base_url';
  public static HEADER_CONTENT_TYPE = ' ';
  public static HEADER_AUTHORIZATION = 'Authorization';
  public static HEADER_TIMEZONE = 'Timezone';
  public static HEADER_TIMEZONE_VALUE = '';
  public static HEADER_ACCEPT_LANGUAGE = 'en';
  public static DEFAULT_LANGUAGE = 'en';
  public static SECRET_KEY = environment.passwordSecretKey;
  public static SHOW_LOCATIONS_ON_DASHBOARD = "show_locations_on_dashboard_map_by_category_ids"
  public static HEADER_AUTHORIZATION_VALUE = '';
  public static USER: any = null;
  public static TOKEN_KEY = 'Token';
  public static SAVE_FILTERS = 'Filters';
  public static USER_DETAILS = 'userDetails';
  public static FILE_UPLOAD_ID = '';
  public static FILE_UPLOAD_NAME = '';
  public static PROFILE_UPLOAD_ID = ''; tenantInfo
  public static PROFILE_UPLOAD_NAME = '';
  public static DISTANCE_UNIT = 'distance_unit';
  public static REFERRAL_CODE = 'driver_referral';
  public static REFERRAL_MANDATORY = 'referral_mandatory';
  public static AIRPORT_LOCATION_CATEGORY_CODE = "airport_location"
  public static TRAIN_LOCATION_CATEGORY_CODE = "train_station_location"
  public static ADMIN_TRIP_ACTION = 'admin_trip_action';
  public static PASSENGER_WALLET = 'passenger_wallet';
  public static TRIP_NOTE = 'trip_note';
  public static DEFAULT_COUNTRY_CODE = '+44';
  public static DEFAULT_COUNTRY = 'default_country';
  public static DEFAULT_CURRENCY = 'default_currency';
  public static ADDITIONAL_STOPS = 'additional_stops';
  public static IS_MANAGE_CORPORATES = 'is_corporate_company';
  public static BOOKING_FEES_APPLICABLE = 'booking_fees_applicable';
  public static ADDITIONAL_CHARGES = 'additional_charges';
  public static ADDITIONAL_CHARGES_REASON_LIST = 'additionalChargesReasonsList';
  public static POSITIVE_NEGATIVE_NUMBER = /^-?[0-9]\d*(\.\d+)?$/;
  public static NAME = /[a-zA-Z0-9][\\sa-zA-Z0-9]{0,19}/;
  public static TENANT_CONFIG = 'TENANT_CONFIG';
  public static IS_RIDE_SHARE_APPLICABLE = 'is_ride_share_applicable';
  public static IS_AIRPORT_ZONES_APPLICABLE = 'airport_zones_applicable';
  public static IS_DRIVER_EXTRA_DOCUMENT_UPLOAD = 'driver_extra_document_upload';
  public static IS_MANAGE_COMPANY = 'is_bidding_applicable';
  public static IS_SEARCH_DRIVER = 'is_dashboard_driver_search';
  public static IS_MULTIPLE_VEHICLE_TO_DRIVER = 'is_multiple_vehicle_to_driver';
  public static IS_LANGUAGE_SUPPORT = 'is_language_support';
  public static IS_RENTAL_APPLICABLE = 'is_rental_service_applicable';
  public static IS_TIME_BASED = 'time_based_surge';
  public static IS_DATE_BASED = 'date_based_surge';
  public static IS_GDPR_SHOW = 'gdpr_compliance';
  public static IS_SELECT_ADDRESS_FROM_MAP = 'select_address_from_map';
  public static SUPPORTED_LANGUAGES = 'supported_languages';
  public static FLIGHT_DETAILS = 'flight_details_feature';
  public static EMAIL_OPTIONAL = 'email_optional_for_role';
  public static FAQ: any = null;
  public static ACCESS_LIST = 'ACCESS_LIST';
  public static ACCESS_MENU = 'ACCESS_MENU';
  public static SERVICE_AREA = 'SERVICE_AREA';
  public static SERVICE_AREA_ALIAS = 'SERVICE_AREA_ALIAS';
  public static SERVICE_CITIES_MAP = 'SERVICE_CITIES_MAP';
  public static MUTLTI_SELECT_SERVICE_CITIES = 'MUTLTI_SELECT_SERVICE_CITIES';
  public static SERVICE_AREA_ID = 'SERVICE_AREA_ID';
  public static CURRENT_USER_CORPORATE_ID = 'CURRENT_USER_CORPORATE_ID';
  public static TIME_SETTINGS = 'TIME_SETTINGS';
  public static DEFAULT_SERVICE_TYPE = 'tenantServiceTypes00000000000001';
  public static DEFAULT_SERVICE_TYPE_00000000000002 = 'tenantServiceTypes00000000000002';
  public static DEFAULT_SERVICE_TYPE_00000000000003 = 'tenantServiceTypes00000000000003';
  public static DEFAULT_PASSENGER_TYPE_00000000000003 = 'taxiPulsePassenger00000000000003';
  public static DEFAULT_DRIVER_TYPE_00000000000004 = 'taxiPulseDriver00000000000000004';
  public static INCIDENT_TYPE_ID = 'it00001';
  public static COMPLAINT_TYPE_ID = 'it00002';
  public static IS_BIDDING_ENABLED = 'is_bidding_applicable';
  public static IS_COMPANY_CATEGORY_APPLICABLE = 'vehicle_type_categories_applicable';
  public static DATE_FORMAT = 'date_format';
  public static DEFAULT_TIME_FORMATE = 'HH:mm';
  public static TIME_LOG_FORMAT = 'HH:MM:SS';
  public static TIME_FORMATE_AMPM = 'hh:mm A';
  public static DEFAULT_MIN_TIME_FORMATE = 'M';
  public static ADD_BOOKING_DATE_FORMAT_PRIMENG = 'dd M yy';
  public static DATE_TIME_FORMAT_MOMENT = 'HH:mm, DD MMM YYYY';
  public static DATE_TIME_AM_PM_FORMAT_MOMENT = 'hh:mm A, DD MMM YYYY';
  public static DATE_ONLY_FORMATE = 'DD MMM YYYY';
  public static DATE_MMDDYYYY_FORMATE = 'MM/DD/YYYY';
  public static SETTING_SERVICE_ID = '';
  public static SERVICE_TYPE = 'ServiceType';
  public static USER_TYPE_LIST = 'userTypeList';
  public static SETTING_RENTAL_WITHOUT_SERVICE = '';
  public static SETTING_RENTAL_WITH_SERVICE = '';
  public static SETTING_TAXI_SERVICE = '';
  public static SETTING_CHAUFFEUR_SERVICE = '';
  public static SETTING_RENTAL_WITHOUT_SERVICE_KEY = 'Rental without driver';
  public static SETTING_RENTAL_WITH_SERVICE_KEY = 'Rental with driver';
  public static SERVICE_CODE_RENTAL = 'Rental';
  public static SETTING_TAXI_SERVICE_KEY = 'Taxi';
  public static SETTING_STAFF_TRANSPORT_SERVICE_KEY = 'StaffTransport';
  public static SETTING_CHAUFFEUR_SERVICE_KEY = 'Chauffeur';
  public static TAXI_BOOK_MAX_TIME = 'book_later_maximum_time';
  public static TAXI_BOOK_MIN_TIME = 'book_later_minimum_time';
  public static RENTAL_BOOK_MIN_TIME = 'book_later_minimum_time_rental';
  public static CHAUFFEUR_BOOK_MIN_TIME = 'book_later_minimum_time_chauffeur';
  public static AUTOMATIC = 'AUTO';
  public static DRIVER_KEY = 'DRIVER';
  public static PASSENGER_KEY = 'PASSENGER';
  public static MANUAL = 'MANL';
  public static LUGGAGE_REQUEST = "LUGGAGE_REQUEST";
  public static MULTIPLE_VEHICLE_REQUEST = "MULTIPLE_VEHICLE_REQUEST";
  public static MULTIPLE_VEHICLE_WITH_LUGGAGE_REQUEST = "MULTIPLE_VEHICLE_WITH_LUGGAGE_REQUEST";
  public static MIN_DISTANCE = 0.1;
  public static MAX_DISTANCE = 1;
  public static PAGINATION = 'Pagination';
  public static BOOKING_DEFAULT_PAGINATION = 50;
  public static ASSIGN_DRIVER_PAGINATION = 99999;
  public static UPLOAD_FILE_URL = AppSettings.BASE_URL + '/' + AppSettings.TENANT + '/secure/file';
  public static GET_FILE_URL = AppSettings.BASE_URL + '/' + AppSettings.TENANT + '/file';
  public static GET_FILE_THUMB_URL = AppSettings.BASE_URL + '/' + AppSettings.TENANT + '/file/thumbnail_';
  public static GET_FILE_GRID_IMG_URL = AppSettings.BASE_URL + '/' + AppSettings.TENANT + '/file/';
  public static EXPORT_URL = AppSettings.BASE_URL + '/' + AppSettings.TENANT;
  public static PRINT_URL = AppSettings.BASE_URL + '/' + AppSettings.TENANT;
  public static DEFAULT_PROFILE_IMAGE_URL = '/assets/images/temp/default_profile.png';
  public static DEFAULT_VEHICLE_IMAGE_URL = '/assets/images/temp/default_vehicle.png';
  public static DEFAULT_EVENT_IMAGE_URL = '/assets/images/temp/default-event.png';
  public static DEFAULT_POWERED_BY_REDIRECT_URL = 'https://mobisoftinfotech.com/solutions/event-transportation-management-app';
  public static DEFAULT_POWERED_BY_LOGO_URL = '/assets/images/temp/powered-by-mi.svg';
  public static CLEAR_NOTIFICATION_INTERVAL: any;
  public static WEBSITE_PATTERN = new RegExp(['^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?',
    '[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})',
    '?(\/.*)?$'].join(''));
  public static WEB_VERSION = 'web_app_version_for_display';
  public static SHORT_CODE_PATTERN = new RegExp(/^([a-zA-Z0-9]+\s?)*$/);
  public static ONLY_SPACE_NOT_ALLOWED_PATTERN = new RegExp(['.*[^ ].*'].join(''));
  public static TEXT_AREA_PATTERN = new RegExp(['^[A-Za-zầáéíóúñüÁÉÍÓÚÑÜ\']+[0-9A-Za-zầáéíóúñüÁÉÍÓÚÑÜ]'].join(''));
  public static FLIGHT_NUMBER_PATTERN = '^[a-zA-Z0-9]+$';
  public static COMMON_REGEX_PATTERN = /^[\wÀ-ÖØ-öø-ÿ!@#$%^*()_+=|~`{}\[\]:";'?/.,\\ -]+$/;
  // public static COMMON_REGEX_PATTERN = new RegExp(/^(?!\d+$)[\wÀ-ÖØ-öø-ÿ!@#$%^*()_+=|~`{}\[\]:";'?/.,\\ -]+$/);
  // public static COMMON_REGEX_PATTERN = new RegExp(/^([a-zA-Z0-9']+\s?)*$/);
  public static ROLE_PATTERN = new RegExp(['^[A-Za-z\\d\-_\\s/\\\\\]*$'].join(''));
  public static PHONE_PATTERN: any = '^[0-9][0-9]*$';
  public static FLOAT_NUMBER_PATTERN = /^\d+(\.\d+)?$/;
  public static FLOAT_NUMBER_PATTERN_ABOVE_ZERO = /^(?=.*[0-9])\d{0,2}(?:\.\d{0,2})?$/;
  public static NUMBER_PATTERN = /^\+?[0-9\-]+$/;
  public static AMOUNT_PATTERN = new RegExp(['^[0-9\\d\.]*$'].join(''));
  public static PERCENT_PATTERN = new RegExp(['^[0-9][0-9]?$|^100$'].join(''));
  public static WALLET_AMOUNT_PATTERN = new RegExp(['^[-|0-9\\d\.]*$'].join(''));
  public static PHONE_CODE = /([0-9]{4,})|[1-9]/;
  // public static EMAIL_PATTERN = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,5})+$/;
  // Legacy pattern (kept for reference): it rejected '+' in local part and allowed invalid domains like '-domain.com'.
  // public static EMAIL_PATTERN = /^(?=.{1,250}$)([a-zA-Z0-9_\.\-]{1,64})+\@(([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9]{2,5}))$/;
  public static EMAIL_PATTERN = /^(?=.{1,250}$)(?=.{1,64}@)[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,63}$/;
  public static SPACE_NOT_ALLOWED_PATTERN = '^[0-9a-zA-Z][a-zA-Z0-9\\.\-\_]+$';
  public static ZIPCODE_PATTERN = new RegExp(['^[0-9]'].join(''));
  public static DIGIT_PATTERN = new RegExp(['^[\\d]*$'].join(''));
  public static YEAR_PATTERN = /^(?:20\d{2}|19\d{2})$/;
  public static RADIUS_DIGIT_PATTERN = /^[0-9|.|0-9]+$/;
  public static NUMBER_NOT_ZERO = new RegExp(['^[1-9][0-9]*$'].join(''));
  public static FEE_PATTERN = new RegExp(['^\\d+(\.\\d{1,2})?$'].join(''));
  public static ALPHA_NUMERIC = new RegExp(['^[A-Za-z0-9]'].join(''));
  public static VALUE_ONE_TO_HUNDRED = new RegExp(['^[1-9][0-9]?$|^100$'].join(''));
  public static NON_ZERO_VALUES = new RegExp(['^[1-9][0-9]*$'].join(''));
  public static HOTEL_PROFILE_UPLOAD_ID = '';
  public static HOTEL_PROFILE_UPLOAD_NAME = '';
  public static PERSON_NAME_PATTERN = '^[a-zA-Z][a-zA-Z\\s\-\_]+$';
  public static COMPANY_AND_PERSON_NAME_PATTERN = '^[a-zA-Z0-9][a-zA-Z0-9\\s\-\_]+$';
  public static PASSWORD_VALIDATIONS = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*[\s&<>]).{8,18}$/;
  public static FAX_PATTERN = /^\+?[0-9\-]+$/;
  public static TIME_ZONE_FIRST_STRING = /[(]/gi;
  public static TIME_ZONE_SECOND_STRING = /[)]/gi;
  public static NO_WHITESPACE = '^[a-zA-Z0-9]*$';
  public static ALPHA_NUMERIC_NEW = '^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$';
  public static DRIVING_LICENSE_PATTERN = /^[a-zA-Z0-9]{1,25}$/;
  public static DEFAULT_NULL_STATUS = 'NA';
  public static TABLE_REFRESH_TIME_INTERVAL = 50000;
  public static MAP_DRIVERS_REFRESH_TIME_INTERVAL = 61000;
  public static BOOKING_DETAILS_MAP_REFRESH_TIME_INTERVAL = 10000;
  public static REPORTS_YEAR_RANGE_START_YEAR = 2020;
  public static PRORITY_DATE_FORMAT = { month: "short", year: "numeric" };
  public static COMMON_PHONE_NUMBER_REGEX = /^[1-9]\d{6,12}$/;
  public static COMMON_DESCRIPTION_REGEX = /^[a-zA-Z0-9\s]+$/;
  public static COMMON_ONE_NINE_ONLY_DIGITS_REGEX = /^[1-9]/;
  public static ONE_TO_THOUSAND_NUMBERS = /^(1000|[1-9][0-9]{0,2})$/;
  public static SHOULD_NOT_ACCEPT_THREE_SPECIAL_SYMBOL = /^(?!.*[<>&])\S.*$/
  public static SHOULD_ACCEPT_EMPTY = /^(?!.*[<>&]).*$/
  public static ACCEPT_ONLY_NUMBER = /^\d+$/
  public static COMMON_NAME_REGEX_MODIFIED = /^\s*(?![0-9]+$)[^<>&]*[a-zA-Z][^<>&]*$/
  public static NUMBER_WITH_COUNTRY_CODE = /^(?:\+\d{1,3}\s?)?(?!0)\d{7,13}$/
  // public static NUMBER_WITH_COUNTRY_CODE = /^(?:\+?\d{1,3}[\s-]?)?(?:\d{2,4}[\s-]?)?\d{6,10}$/
  public static COMMON_NAME_REGEX = /^[0-9]*[^<>&'0-9]*[a-zA-Z][^<>&]*$/;
  public static EMAIL_PATTERN1 = /^[\w\.-]+@[\w\.-]+\.\w+$/;
  public static RESTRICT_ONLY_SPECIAL_SYMBOL = /^\s*(?=.*[a-zA-Z0-9])\s*[^\s<>&`]+(?:\s+[^\s<>&`]+)*\s*$/;

  public static STATUS_FILTER = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'true' },
    { label: 'Inactive', value: 'false' }
  ];

  public static STATUS_OPTIONS = [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false }
  ];

  public static WHEELCHAIR_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' }
  ];

  public static STATUS_FILTER_VEHICLES = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'true' },
    { label: 'Inactive', value: 'false' }
  ];

  public static PRIVILEGE_COLDE = {
    LOCATIONS: 'locations',
    SOCIAL_JOURNEYS: 'social_journeys',
    DEPARTURE_JOURNEYS: 'departure_journeys',
    MAX_PASSENGER_PER_TRIP: 'max_passenger_per_trip',
    MAX_TRIP_PER_DAY: 'max_trip_per_day',
    MAX_WHEELCHAIR_PER_TRIP: 'max_wheelchair_per_trip',
    MAX_CHILDSEAT_PER_TRIP: 'max_childseat_per_trip',
    MAX_BABYSEAT_PER_TRIP: 'max_babyseat_per_trip',
    PASSENGER_APP: 'passenger_app',

    MAX_BAGGAGE_COUNT: 'max_baggage_count',
    INTERMEDIATE_STOP: 'intermediate_stop',
    LUGGAGE_JOURNEYS: 'luggage_journeys_allowed',
    TRANSPORT_SERVICES: 'transport_services',
    GOOGLE_LOCATION_FOR_BOOKING: 'google_location_for_booking',
    EDIT_ACCOMMODATION_ADDRESS: 'edit_stay_address',
    GOOGLE_ADDRESS_FOR_ACCOMMODATION: 'google_location_for_stay',
    MULTIZONE_BOOKING_ALLOWED: 'multizone_booking_allowed'

  };

  public static PRIVILEGE_PERMISSION_ID = {
    PASSENGER_APP: 'permevnvnjv00001',
    MAX_PASSENGER_PER_TRIP: 'permevnvnjv00002',
    MAX_TRIP_PER_DAY: 'permevnvnjv00003',
    MAX_WHEELCHAIR_PER_TRIP: 'permevnvnjv00004',
    MAX_CHILDSEAT_PER_TRIP: 'permevnvnjv00005',
    MAX_BABYSEAT_PER_TRIP: 'permevnvnjv00009',
    DEPARTURE_JOURNEYS: 'permevnvnjv00006',
    SOCIAL_JOURNEYS: 'permevnvnjv00007',
    LOCATIONS: 'permevnvnjv00008',

    MAX_BAGGAGE_COUNT: 'permevnvnjv00016',
    INTERMEDIATE_STOP: 'permevnvnjv00012',
    LUGGAGE_JOURNEYS: 'permevnvnjv00010',
    TRANSPORT_SERVICES: 'permevnvnjv00011',
    GOOGLE_LOCATION_FOR_BOOKING: 'permevnvnjv00013',
    EDIT_ACCOMMODATION_ADDRESS: 'permevnvnjv00015',
    GOOGLE_ADDRESS_FOR_ACCOMMODATION: 'permevnvnjv00014',
    MULTIZONE_BOOKING_ALLOWED: 'permevnvnjv00017',

  };


  public static MESSAGE_TYPE = { SUCCESS: 'success', ERROR: 'error', WARNING: 'warning', INFO: 'info' };

  public static LOCATION_TYPES = {
    PARKING: 'locCatId00001',
    QUEUE: 'locCatId00002',
    STAY_LOCATION: 'locCatId00003',
  };

  public static All_LOCATION_TYPES = {
    PARKING: 'locCatId00001',
    QUEUE: 'locCatId00002',
    STAY_LOCATION: 'locCatId00003',
    OTHER_LOCATION: 'locCatId00004',
    AIRPORT_LOCATION: 'locCatId00006',
    TRAIN_LOCATION: 'locCatId00009',
  };

  public static CHILDREN_SEAT = {
    CHILD_SEAT: 'C',
    BABY_SEAT: 'B'
  };

  // public static NO_SPACE = '^[a-zA-Z0-9]*$';
  public static DAYS_COLLECTION = [
    { label: 'Sun', value: '1' },
    { label: 'Mon', value: '2' },
    { label: 'Tue', value: '3' },
    { label: 'Wed', value: '4' },
    { label: 'Thu', value: '5' },
    { label: 'Fri', value: '6' },
    { label: 'Sat', value: '7' }
  ];

  public static LOCATION_MAP_STYLE_DEFAULT = []

  public static LOCATION_MAP_STYLE_DARK = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f3d19c" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#2f3948" }],
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#515c6d" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#17263c" }],
    },
  ]

  public static COUNTRY_CODE = [
    // { label: 'Code', value: '' },
    { label: '+1', value: '+1' },
    { label: '+7', value: '+7' },
    { label: '+20', value: '+20' },
    { label: '+27', value: '+27' },
    { label: '+30', value: '+30' },
    { label: '+31', value: '+31' },
    { label: '+32', value: '+32' },
    { label: '+33', value: '+33' },
    { label: '+34', value: '+34' },
    { label: '+36', value: '+36' },
    { label: '+39', value: '+39' },
    { label: '+40', value: '+40' },
    { label: '+41', value: '+41' },
    { label: '+43', value: '+43' },
    { label: '+44', value: '+44' },
    { label: '+45', value: '+45' },
    { label: '+46', value: '+46' },
    { label: '+47', value: '+47' },
    { label: '+48', value: '+48' },
    { label: '+49', value: '+49' },
    { label: '+51', value: '+51' },
    { label: '+52', value: '+52' },
    { label: '+53', value: '+53' },
    { label: '+54', value: '+54' },
    { label: '+55', value: '+55' },
    { label: '+56', value: '+56' },
    { label: '+57', value: '+57' },
    { label: '+58', value: '+58' },
    { label: '+60', value: '+60' },
    { label: '+61', value: '+61' },
    { label: '+62', value: '+62' },
    { label: '+63', value: '+63' },
    { label: '+64', value: '+64' },
    { label: '+65', value: '+65' },
    { label: '+66', value: '+66' },
    { label: '+81', value: '+81' },
    { label: '+82', value: '+82' },
    { label: '+84', value: '+84' },
    { label: '+86', value: '+86' },
    { label: '+90', value: '+90' },
    { label: '+91', value: '+91' },
    { label: '+92', value: '+92' },
    { label: '+93', value: '+93' },
    { label: '+94', value: '+94' },
    { label: '+95', value: '+95' },
    { label: '+98', value: '+98' },
    { label: '+212', value: '+212' },
    { label: '+213', value: '+213' },
    { label: '+216', value: '+216' },
    { label: '+218', value: '+218' },
    { label: '+220', value: '+220' },
    { label: '+221', value: '+221' },
    { label: '+222', value: '+222' },
    { label: '+223', value: '+223' },
    { label: '+224', value: '+224' },
    { label: '+225', value: '+225' },
    { label: '+226', value: '+226' },
    { label: '+227', value: '+227' },
    { label: '+228', value: '+228' },
    { label: '+229', value: '+229' },
    { label: '+230', value: '+230' },
    { label: '+231', value: '+231' },
    { label: '+232', value: '+232' },
    { label: '+233', value: '+233' },
    { label: '+234', value: '+234' },
    { label: '+235', value: '+235' },
    { label: '+236', value: '+236' },
    { label: '+237', value: '+237' },
    { label: '+238', value: '+238' },
    { label: '+239', value: '+239' },
    { label: '+240', value: '+240' },
    { label: '+241', value: '+241' },
    { label: '+242', value: '+242' },
    { label: '+243', value: '+243' },
    { label: '+244', value: '+244' },
    { label: '+245', value: '+245' },
    { label: '+248', value: '+248' },
    { label: '+249', value: '+249' },
    { label: '+250', value: '+250' },
    { label: '+251', value: '+251' },
    { label: '+252', value: '+252' },
    { label: '+253', value: '+253' },
    { label: '+254', value: '+254' },
    { label: '+255', value: '+255' },
    { label: '+256', value: '+256' },
    { label: '+257', value: '+257' },
    { label: '+258', value: '+258' },
    { label: '+260', value: '+260' },
    { label: '+261', value: '+261' },
    { label: '+262', value: '+262' },
    { label: '+263', value: '+263' },
    { label: '+264', value: '+264' },
    { label: '+265', value: '+265' },
    { label: '+266', value: '+266' },
    { label: '+267', value: '+267' },
    { label: '+268', value: '+268' },
    { label: '+269', value: '+269' },
    { label: '+290', value: '+290' },
    { label: '+291', value: '+291' },
    { label: '+297', value: '+297' },
    { label: '+298', value: '+298' },
    { label: '+299', value: '+299' },
    { label: '+350', value: '+350' },
    { label: '+351', value: '+351' },
    { label: '+352', value: '+352' },
    { label: '+353', value: '+353' },
    { label: '+355', value: '+355' },
    { label: '+356', value: '+356' },
    { label: '+357', value: '+357' },
    { label: '+358', value: '+358' },
    { label: '+359', value: '+359' },
    { label: '+370', value: '+370' },
    { label: '+371', value: '+371' },
    { label: '+372', value: '+372' },
    { label: '+373', value: '+373' },
    { label: '+374', value: '+374' },
    { label: '+375', value: '+375' },
    { label: '+376', value: '+376' },
    { label: '+377', value: '+377' },
    { label: '+378', value: '+378' },
    { label: '+380', value: '+380' },
    { label: '+381', value: '+381' },
    { label: '+382', value: '+382' },
    { label: '+385', value: '+385' },
    { label: '+386', value: '+386' },
    { label: '+387', value: '+387' },
    { label: '+389', value: '+389' },
    { label: '+420', value: '+420' },
    { label: '+421', value: '+421' },
    { label: '+423', value: '+423' },
    { label: '+500', value: '+500' },
    { label: '+501', value: '+501' },
    { label: '+502', value: '+502' },
    { label: '+503', value: '+503' },
    { label: '+504', value: '+504' },
    { label: '+505', value: '+505' },
    { label: '+506', value: '+506' },
    { label: '+507', value: '+507' },
    { label: '+508', value: '+508' },
    { label: '+509', value: '+509' },
    { label: '+590', value: '+590' },
    { label: '+591', value: '+591' },
    { label: '+592', value: '+592' },
    { label: '+593', value: '+593' },
    { label: '+595', value: '+595' },
    { label: '+597', value: '+597' },
    { label: '+598', value: '+598' },
    { label: '+670', value: '+670' },
    { label: '+672', value: '+672' },
    { label: '+673', value: '+673' },
    { label: '+674', value: '+674' },
    { label: '+675', value: '+675' },
    { label: '+676', value: '+676' },
    { label: '+677', value: '+677' },
    { label: '+678', value: '+678' },
    { label: '+679', value: '+679' },
    { label: '+680', value: '+680' },
    { label: '+681', value: '+681' },
    { label: '+682', value: '+682' },
    { label: '+683', value: '+683' },
    { label: '+685', value: '+685' },
    { label: '+686', value: '+686' },
    { label: '+687', value: '+687' },
    { label: '+688', value: '+688' },
    { label: '+689', value: '+689' },
    { label: '+690', value: '+690' },
    { label: '+691', value: '+691' },
    { label: '+692', value: '+692' },
    { label: '+850', value: '+850' },
    { label: '+852', value: '+852' },
    { label: '+853', value: '+853' },
    { label: '+855', value: '+855' },
    { label: '+856', value: '+856' },
    { label: '+870', value: '+870' },
    { label: '+880', value: '+880' },
    { label: '+886', value: '+886' },
    { label: '+960', value: '+960' },
    { label: '+961', value: '+961' },
    { label: '+962', value: '+962' },
    { label: '+963', value: '+963' },
    { label: '+964', value: '+964' },
    { label: '+965', value: '+965' },
    { label: '+966', value: '+966' },
    { label: '+967', value: '+967' },
    { label: '+968', value: '+968' },
    { label: '+971', value: '+971' },
    { label: '+972', value: '+972' },
    { label: '+973', value: '+973' },
    { label: '+974', value: '+974' },
    { label: '+975', value: '+975' },
    { label: '+976', value: '+976' },
    { label: '+977', value: '+977' },
    { label: '+992', value: '+992' },
    { label: '+993', value: '+993' },
    { label: '+994', value: '+994' },
    { label: '+995', value: '+995' },
    { label: '+996', value: '+996' },
    { label: '+998', value: '+998' }
  ];

  public static COUNTRY_CODE_SHUTTLE = [
    // { label: 'Code', value: '' },
    { label: '+1', value: '1' },
    { label: '+7', value: '7' },
    { label: '+20', value: '20' },
    { label: '+27', value: '27' },
    { label: '+30', value: '30' },
    { label: '+31', value: '31' },
    { label: '+32', value: '32' },
    { label: '+33', value: '33' },
    { label: '+34', value: '34' },
    { label: '+36', value: '36' },
    { label: '+39', value: '39' },
    { label: '+40', value: '40' },
    { label: '+41', value: '41' },
    { label: '+43', value: '43' },
    { label: '+44', value: '44' },
    { label: '+45', value: '45' },
    { label: '+46', value: '46' },
    { label: '+47', value: '47' },
    { label: '+48', value: '48' },
    { label: '+49', value: '49' },
    { label: '+51', value: '51' },
    { label: '+52', value: '52' },
    { label: '+53', value: '53' },
    { label: '+54', value: '54' },
    { label: '+55', value: '55' },
    { label: '+56', value: '56' },
    { label: '+57', value: '57' },
    { label: '+58', value: '58' },
    { label: '+60', value: '60' },
    { label: '+61', value: '+61' },
    { label: '+61', value: '61' },
    { label: '+62', value: '62' },
    { label: '+63', value: '63' },
    { label: '+64', value: '64' },
    { label: '+65', value: '65' },
    { label: '+66', value: '66' },
    { label: '+81', value: '81' },
    { label: '+82', value: '82' },
    { label: '+84', value: '84' },
    { label: '+86', value: '86' },
    { label: '+90', value: '90' },
    { label: '+91', value: '91' },
    { label: '+92', value: '92' },
    { label: '+93', value: '93' },
    { label: '+94', value: '94' },
    { label: '+95', value: '95' },
    { label: '+98', value: '98' },
    { label: '+212', value: '212' },
    { label: '+213', value: '213' },
    { label: '+216', value: '216' },
    { label: '+218', value: '218' },
    { label: '+220', value: '220' },
    { label: '+221', value: '221' },
    { label: '+222', value: '222' },
    { label: '+223', value: '223' },
    { label: '+224', value: '224' },
    { label: '+225', value: '225' },
    { label: '+226', value: '226' },
    { label: '+227', value: '227' },
    { label: '+228', value: '228' },
    { label: '+229', value: '229' },
    { label: '+230', value: '230' },
    { label: '+231', value: '231' },
    { label: '+232', value: '232' },
    { label: '+233', value: '233' },
    { label: '+234', value: '234' },
    { label: '+235', value: '235' },
    { label: '+236', value: '236' },
    { label: '+237', value: '237' },
    { label: '+238', value: '238' },
    { label: '+239', value: '239' },
    { label: '+240', value: '240' },
    { label: '+241', value: '241' },
    { label: '+242', value: '242' },
    { label: '+243', value: '243' },
    { label: '+244', value: '244' },
    { label: '+245', value: '245' },
    { label: '+248', value: '248' },
    { label: '+249', value: '249' },
    { label: '+250', value: '250' },
    { label: '+251', value: '251' },
    { label: '+252', value: '252' },
    { label: '+253', value: '253' },
    { label: '+254', value: '254' },
    { label: '+255', value: '255' },
    { label: '+256', value: '256' },
    { label: '+257', value: '257' },
    { label: '+258', value: '258' },
    { label: '+260', value: '260' },
    { label: '+261', value: '261' },
    { label: '+262', value: '262' },
    { label: '+263', value: '263' },
    { label: '+264', value: '264' },
    { label: '+265', value: '265' },
    { label: '+266', value: '266' },
    { label: '+267', value: '267' },
    { label: '+268', value: '268' },
    { label: '+269', value: '269' },
    { label: '+290', value: '290' },
    { label: '+291', value: '291' },
    { label: '+297', value: '297' },
    { label: '+298', value: '298' },
    { label: '+299', value: '299' },
    { label: '+350', value: '350' },
    { label: '+351', value: '351' },
    { label: '+352', value: '352' },
    { label: '+353', value: '353' },
    { label: '+355', value: '355' },
    { label: '+356', value: '356' },
    { label: '+357', value: '357' },
    { label: '+358', value: '358' },
    { label: '+359', value: '359' },
    { label: '+370', value: '370' },
    { label: '+371', value: '371' },
    { label: '+372', value: '372' },
    { label: '+373', value: '373' },
    { label: '+374', value: '374' },
    { label: '+375', value: '375' },
    { label: '+376', value: '376' },
    { label: '+377', value: '377' },
    { label: '+378', value: '378' },
    { label: '+380', value: '380' },
    { label: '+381', value: '381' },
    { label: '+382', value: '382' },
    { label: '+385', value: '385' },
    { label: '+386', value: '386' },
    { label: '+387', value: '387' },
    { label: '+389', value: '389' },
    { label: '+420', value: '420' },
    { label: '+421', value: '421' },
    { label: '+423', value: '423' },
    { label: '+500', value: '500' },
    { label: '+501', value: '501' },
    { label: '+502', value: '502' },
    { label: '+503', value: '503' },
    { label: '+504', value: '504' },
    { label: '+505', value: '505' },
    { label: '+506', value: '506' },
    { label: '+507', value: '507' },
    { label: '+508', value: '508' },
    { label: '+509', value: '509' },
    { label: '+590', value: '590' },
    { label: '+591', value: '591' },
    { label: '+592', value: '592' },
    { label: '+593', value: '593' },
    { label: '+595', value: '595' },
    { label: '+597', value: '597' },
    { label: '+598', value: '598' },
    { label: '+670', value: '670' },
    { label: '+672', value: '672' },
    { label: '+673', value: '673' },
    { label: '+674', value: '674' },
    { label: '+675', value: '675' },
    { label: '+676', value: '676' },
    { label: '+677', value: '677' },
    { label: '+678', value: '678' },
    { label: '+679', value: '679' },
    { label: '+680', value: '680' },
    { label: '+681', value: '681' },
    { label: '+682', value: '682' },
    { label: '+683', value: '683' },
    { label: '+685', value: '685' },
    { label: '+686', value: '686' },
    { label: '+687', value: '687' },
    { label: '+688', value: '688' },
    { label: '+689', value: '689' },
    { label: '+690', value: '690' },
    { label: '+691', value: '691' },
    { label: '+692', value: '692' },
    { label: '+850', value: '850' },
    { label: '+852', value: '852' },
    { label: '+853', value: '853' },
    { label: '+855', value: '855' },
    { label: '+856', value: '856' },
    { label: '+870', value: '870' },
    { label: '+880', value: '880' },
    { label: '+886', value: '886' },
    { label: '+960', value: '960' },
    { label: '+961', value: '961' },
    { label: '+962', value: '962' },
    { label: '+963', value: '963' },
    { label: '+964', value: '964' },
    { label: '+965', value: '965' },
    { label: '+966', value: '966' },
    { label: '+967', value: '967' },
    { label: '+968', value: '968' },
    { label: '+971', value: '971' },
    { label: '+972', value: '972' },
    { label: '+973', value: '973' },
    { label: '+974', value: '974' },
    { label: '+975', value: '975' },
    { label: '+976', value: '976' },
    { label: '+977', value: '977' },
    { label: '+992', value: '992' },
    { label: '+993', value: '993' },
    { label: '+994', value: '994' },
    { label: '+995', value: '995' },
    { label: '+996', value: '996' },
    { label: '+998', value: '998' }
  ];
  public static CARS_ICONS = [
    { class: 'car-icon-0', value: '' },
    { class: 'car-icon-1', value: '1' },
    { class: 'car-icon-2', value: '2' },
    { class: 'car-icon-3', value: '3' },
    { class: 'car-icon-4', value: '4' },
    { class: 'car-icon-5', value: '5' },
    { class: 'car-icon-6', value: '6' },
    { class: 'car-icon-7', value: '7' },
    { class: 'car-icon-8', value: '8' },
    { class: 'car-icon-9', value: '9' },
    { class: 'car-icon-10', value: '10' },
    { class: 'car-icon-11', value: '11' },
    { class: 'car-icon-12', value: '12' },
    { class: 'car-icon-13', value: '13' },
    { class: 'car-icon-14', value: '14' },
    { class: 'car-icon-15', value: '15' },
    { class: 'car-icon-16', value: '16' },
    { class: 'car-icon-17', value: '17' },
    { class: 'car-icon-18', value: '18' },
    { class: 'car-icon-19', value: '19' },
    { class: 'car-icon-20', value: '20' },
    { class: 'car-icon-21', value: '21' },
    { class: 'car-icon-22', value: '22' },
    { class: 'car-icon-23', value: '23' },
    { class: 'car-icon-24', value: '24' },
    { class: 'car-icon-25', value: '25' },
    { class: 'car-icon-26', value: '26' },

  ];


  public static LOGGED_IN_ROLE = '';
  public static ADMINROLEID = 'Tenant Admin';
  public static DISPATCHERROLEID = 'Dispatcher Admin';
  public static CORPORATEROLEID = 'Corporate Admin';
  public static HOTELBOOKINGROLECODE = 'Hotel Booking';
  public static CORPORATEBOOKINGROLECODE = 'Corporate Booking';
  public static EMPLOYEE_ID = '';
  public static DEPARTMENT_ID = '';

  public static SALES_QUOTATION_TRIP_STATUS = [
    {
      label: 'Select',
      value: ''
    }, {
      label: 'New Request',
      value: 'NEW_REQUEST'
    }, {
      label: 'Quote Sent',
      value: 'QUOTE_SENT'
    }, {
      label: 'Quote Rejected',
      value: 'QUOTE_REJECTED'
    }, {
      label: 'Quote Accepted',
      value: 'QUOTE_ACCEPTED'
    }, {
      label: 'Cancelled',
      value: 'CANCELED'
    }
  ];

  public static BOOKING_DRIVER_ASSIGNED_STATUS = [20, 90, 70, 80, 40, 130, 120, 170, 50, 140, 150, 160, 100];



  public static RENTAL_SERVICE_TYPE = [
    'Rental with driver with fuel',
    'Rental without driver without fuel',
    'Rental with driver without fuel',
    'Rental without driver with fuel',
    'Chauffeur'
  ];

  public static ASSIGN_BOOKING_STATUS_ARRAY = [10];
  public static DRIVER_IS_ARRIVED = [90];
  public static BOOOKING_QUOTATION_ACCEPTED = [30];
  public static REASSIGN_BOOKING_STATUS_ARRAY = [80, 40, 41];
  public static COMPLETE_BOOKING_STATUS_ARRAY = [130, 120, 170, 50];
  public static DRIVER_ON_THE_WAY = [80];
  public static SECURITY_CHECK = [100];
  public static END_TRIP = [110];
  public static CAR_RETURN_CHECK = [140];
  public static RETURN_SECURITY_CHECK = [150];
  public static ON_TRIP = [130];

  public static BOOKING_DETAILS_STATUS_DISABLE_ARRAY = [
    120, 170, 50, 30
  ];

  public static BOOKING_STATUS = {
    END_TRIP: 140,
  }




  public static TRANSMISSION_TYPE = [
    {
      label: 'Please select',
      value: ''
    },
    {
      label: 'Both (Automatic/Manual)',
      value: 'BOTH'
    },
    {
      label: 'Automatic',
      value: 'AUTO'
    },
    {
      label: 'Manual',
      value: 'MANL'
    }
  ];

  public static HOTEL_PRICING_LINK = 'pricing-packages-details';
  public static HOTEL_ROUTE_LINK = 'route-pricing-details';
  public static HOTEL_Profile_image = '/assets/images/temp/default_hotel.png';
  public static NOTIFICATION_INTERVAL = 60 * 1000; // 1 min


  public static MAP_OPTION = {
    center: {
      lat: 27.7676, lng: 82.6403
    },
    streetViewControl: false,
    zoom: 11,
    zoomControl: false
  };
  // public static MAP_OPTIONS_POSITION = { lat: 27.7676, lng: 82.6403 };
  public static MAP_OPTIONS_POSITION = { lat: 18.5482582, lng: 73.77390079999999 };

  public static SERVICE_TYPE_RENTAL = 'Rental';
  public static SERVICE_TYPE_TAXI = 'Taxi';
  public static SERVICE_TYPE_OCCASIONAL = 'Occasional Ride';

  public static DATE_FORMATTER = 'MMM DD, YYYY hh:mm A';

  public static PASSENGER_TYPES = [
    {
      label: 'Private',
      value: 'Private'
    }, {
      label: 'Corporate',
      value: 'corporate'
    }
  ];

  public static PASSENGER_TYPES_MANUAL_BOOKING = [
    { label: 'Please Select', value: '' },
    { label: 'Guest Users', value: 'guestPassenger' },
    { label: 'App Users', value: 'appPassenger' }
  ];

  public static DRIVER_TYPES_MANUAL_BOOKING = [
    { label: 'Please Select', value: '' },
    { label: 'Select Manually', value: 'selectDriver' },
    { label: 'Auto Dispatch', value: 'automatic' },
  ];

  public static twentyThreeFiftyNineLapse = 86399000;

  public static IGNORE_LINK = ['edit-corporate', 'corporate-details', 'hotel-details', 'reports', 'settings'];

  public static FILE_UPLOAD_MAX_SIZE_IN_BYTE = 18874368;
  public static FILE_UPLOAD_MAX_SIZE_IN_BYTE_IMAGE = 180000000;


  public static SECURITY_CHECK_TYPE = {
    security: 'SECURITY_CHECK',
    delivery: 'DELIVERY_CHECK',
    carReturn: 'CAR_RETURN_CHECK',
    returnSecurity: 'RETURN_SECURITY_CHECK',
  };

  public static PAYMENT_MODE = [{
    label: 'Cash',
    value: 'CASH'
  }];

  public static GRID_LOCATIONS = [];
  public static DRIVER_DUTY_STATUS_OPTIONS = [
    { label: 'ON', value: true },
    { label: 'OFF', value: false },
  ];

  public static DRIVER_STATUS_FILTER_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'true' },
    { label: 'Inactive', value: 'false' }
  ];

  public static DRIVER_AVAILABLE_FILTER_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'ON', value: 'ON' },
    { label: 'OFF', value: 'OFF' }
  ];
  public static PAYMENT_GATEWAY = 'payment_gateway'
  public static PAYMENT_GATEWAY_WING = 'WING'
  public static PAYMENT_TYPES = 'payment_types'
  public static DEFAULT_MAP_ROUTE_COLOR = '#06A0FF';
  public static DEFAULT_ROUTE_COLOR = '#000000';
  public static IS_OCCASIONAL_TRIP = 'occasional_trip';
  public static IS_CAPTURE_ACTIVITY_LOGS = 'capture_activity_logs';
  public static HEADER_NOT_REQUIRED = ['/signin', '/trackmylocation', '/'];
  public static GENDER_OPTION = [
    { label: 'Please select', value: '' },
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' }
  ];

  public static SUB_BOOKINMG_SERVICE_TYPES = {
    INBOUND: 'INBOUND',
    OUTBOUND: 'OUTBOUND',
    OTHER: 'OTHER',
    ALL: 'ALL'
  };

  public static SUB_BOOKINMG_SERVICE_TYPES_LIST = {
    INBOUNDOTHER: 'INBOUNDOTHER',
    ALL: 'ALL',
    INBOUND: 'INBOUND',
    OUTBOUND: 'OUTBOUND',
    CRITICAL: 'CRITICAL',
    VEHICLETRANSFER: 'VEHICLETRANSFER',
    THIRDPARTY: 'THIRDPARTY',
    LUGGAGEREQUEST: 'LUGGAGEREQUEST',
    MERGE: 'MERGE',
    HISTORY: 'HISTORY',
    DEDICATED: 'DEDICATED',
    OTHER: 'OTHER',
  

  };

  public static SUB_SERVICE_TYPES_OPTIONS_LIST_FOR_REPORTS = [
    { label: 'Inbound', value: 'INBOUND' },
    { label: 'Outbound', value: 'OUTBOUND' },
    // { label: 'Critical', value: 'CRITICAL' },
    { label: 'Vehicle Transfer', value: 'VEHICLE_TRANSFER' },
    // { label: 'Third Party', value: 'THIRD_PARTY' }
  ];

  public static LOCATION_MAP_STYLE = [
    {
      'featureType': 'water',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#e9e9e9'
        },
        {
          'lightness': 17
        }
      ]
    },
    {
      'featureType': 'landscape',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#f5f5f5'
        },
        {
          'lightness': 20
        }
      ]
    },
    {
      'featureType': 'road.highway',
      'elementType': 'geometry.fill',
      'stylers': [
        {
          'color': '#ffffff'
        },
        {
          'lightness': 17
        }
      ]
    },
    {
      'featureType': 'road.highway',
      'elementType': 'geometry.stroke',
      'stylers': [
        {
          'color': '#ffffff'
        },
        {
          'lightness': 29
        },
        {
          'weight': 0.2
        }
      ]
    },
    {
      'featureType': 'road.arterial',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#ffffff'
        },
        {
          'lightness': 18
        }
      ]
    },
    {
      'featureType': 'road.local',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#ffffff'
        },
        {
          'lightness': 16
        }
      ]
    },
    {
      'featureType': 'poi',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#f5f5f5'
        },
        {
          'lightness': 21
        }
      ]
    },
    {
      'featureType': 'poi.park',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#dedede'
        },
        {
          'lightness': 21
        }
      ]
    },
    {
      'elementType': 'labels.text.stroke',
      'stylers': [
        {
          'visibility': 'on'
        },
        {
          'color': '#ffffff'
        },
        {
          'lightness': 16
        }
      ]
    },
    {
      'elementType': 'labels.text.fill',
      'stylers': [
        {
          'saturation': 36
        },
        {
          'color': '#333333'
        },
        {
          'lightness': 40
        }
      ]
    },
    {
      'elementType': 'labels.icon',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'transit',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#f2f2f2'
        },
        {
          'lightness': 19
        }
      ]
    },
    {
      'featureType': 'administrative',
      'elementType': 'geometry.fill',
      'stylers': [
        {
          'color': '#fefefe'
        },
        {
          'lightness': 20
        }
      ]
    },
    {
      'featureType': 'administrative',
      'elementType': 'geometry.stroke',
      'stylers': [
        {
          'color': '#fefefe'
        },
        {
          'lightness': 17
        },
        {
          'weight': 1.2
        }
      ]
    }
  ];

  public static YEAR_RANGE_SELECTION = '2000:2035'

  public static JOURNEY_TYPES = [
    'GENERAL',
    'VEHICLE_TRANSFER',
    'SHUTTLE',
    'SPECIAL_EVENT',
    'THIRD_PARTY',
    'SHUTTLE_BOOKING',
    'DEDICATED',
  ];

  public static JOURNEY_TYPE_VALUES = {
    GENERAL: 'GENERAL',
    VEHICLE_TRANSFER: 'VEHICLE_TRANSFER',
    SHUTTLE: 'SHUTTLE',
    SPECIAL_EVENT: 'SPECIAL_EVENT',
    THIRD_PARTY: 'THIRD_PARTY',
    MERGE: 'MERGE',
    SHUTTLE_BOOKING: 'SHUTTLE_BOOKING',
    DEDICATED: 'DEDICATED',

  };

  public static PAST_DEDICATED_BOOKING_STATUS = [3020, 3021, 3022];
  public static PAST_DEDICATED_DAYWISE_TOUR_STATUS = [1081, 1091, 1099];
  public static DAY_SKIPPED_DEDICATED_DAYWISE_TOUR_STATUS = [1099];

  public static DEDICATED_BOOKING_STATUS_CODES = {
    UPCOMING: 3001,
    ONGOING: 3011,
    COMPLETED: 3020,
    CANCELLATION: 3021,
    EXPIRED: 3022
  };

  public static DEDICATED_DAYWISE_TOUR_STATUS_CODES = {
    PENDING_ASSIGNMENT: 1001,
    DRIVER_ASSIGNED: 1011,
    ACKNOWLEDGED: 1021,
    REQUEST_SENT: 1031,
    RECONFIRM: 1041,
    ON_WAY_TO_PICKUP: 1051,
    ARRIVED_AT_PICKUP: 1061,
    ON_TRIP: 1071,
    COMPLETED: 1081,
    CANCELLED: 1091,
    DAY_SKIPPED: 1099,
  };

  public static DEDICATED_STOPWISE_BOOKING_STATUS_CODES = {
    UPCOMING: 2001,
    STARTED: 2011,
    COMPLETED: 2021,
  };

  public static DEDICATED_MAIN_BOOKING_STATUS_OPTIONS = [
    { label: 'Upcoming', value: 3001 },
    { label: 'Ongoing', value: 3011 },
    { label: 'Completed', value: 3020 },
    { label: 'Cancelled', value: 3021 },
    { label: 'Expired', value: 3022 }
  ];

  public static DEDICATED_DAYWISE_TOUR_STATUS_OPTIONS = [
    { label: 'Pending Assignment', value: 1001, disabled: true },
    { label: 'Driver Assigned', value: 1011, disabled: true },
    { label: 'Request Sent', value: 1031, disabled: true },
    { label: 'Acknowledged', value: 1021 },
    // { label: 'Reconfirm', value: 1041 },
    { label: 'On way to pickup', value: 1051 },
    { label: 'Arrived at pickup', value: 1061 },
    { label: 'On Trip', value: 1071, disabled: true },
    { label: 'Completed', value: 1081 },
    { label: 'Cancelled', value: 1091 },
    { label: 'Day Skipped', value: 1099, disabled: true },
    { label: 'Expired', value: 1098, disabled: true }
  ];

  public static DEDICATED_STOPWISE_BOOKING_STATUS_OPTIONS = [
    { label: 'Upcoming', value: 2001 },
    { label: 'Started', value: 2011 },
    { label: 'Completed', value: 2021 }
  ];

  public static DEDICATED_DAYWISE_TOUR_STATUS_FILTER_OPTIONS = [
    { label: 'Pending Assignment', value: 1001 },
    { label: 'Driver Assigned', value: 1011 },
    { label: 'Request Sent', value: 1031 },
    { label: 'Acknowledged', value: 1021 },
    // { label: 'Reconfirm', value: 1041 },
    { label: 'On way to pickup', value: 1051 },
    { label: 'Arrived at pickup', value: 1061 },
    { label: 'On Trip', value: 1071 },
    { label: 'Completed', value: 1081 },
    { label: 'Cancelled', value: 1091 },
    { label: 'Day Skipped', value: 1099 },
    { label: 'Expired', value: 1098 }
  ];

  public static PREFERED_FOR_USERS_TYPES = {
    PLAYER_COACH: 'PLAYER_COACH',
    NON_PLAYER_COACH: 'NON_PLAYER_COACH',
    ALL: 'ALL',
  };

  public static DUMMY_VEHICLES_FILTER = [
    { label: 'All', value: '' },
    { label: 'Actual', value: 'ACTUAL' },
    { label: 'Dummy', value: 'DUMMY' },
  ];

  // old
  // public static BOOKING_STATUS_CODES_OPTIONS = [
  //   { label: 'New Request', value: 10, disabled: true },
  //   { label: 'Driver Assigned', value: 40, disabled: true },
  //   { label: 'Accepted', value: 41 },
  //   { label: 'Driver On The Way', value: 80 },
  //   { label: 'Driver Arrived', value: 90 },
  //   { label: 'On Trip', value: 130 },
  //   { label: 'Completed', value: 140 },
  //   { label: 'Expired', value: 71, disabled: true },
  //   { label: 'Cancelled', value: 120 },
  // ];

  // public static BOOKING_STATUS_CODES_FILTER_OPTIONS = [
  //   { label: 'All', value: '' },
  //   { label: 'New Request', value: 10 },
  //   { label: 'Driver Assigned', value: 40 },
  //   { label: 'Accepted', value: 41 },
  //   { label: 'Driver On The Way', value: 80 },
  //   { label: 'Driver Arrived', value: 90 },
  //   { label: 'On Trip', value: 130 },
  //   { label: 'Completed', value: 140 },
  //   { label: 'Expired', value: 71 },
  //   { label: 'Cancelled', value: 120 },
  // ];

  // old
  // public static BOOKING_STATUS_CODES = {
  //   NEW_REQUEST: 10,
  //   ADMIN_CONFIRMED: 25,
  //   DRIVER_ASSIGNED: 40,
  //   DRIVER_CONFIRMED: 43,
  //   DRIVER_RECONFIRM: 45,
  //   ACCEPTED: 47,
  //   DRIVER_ON_THE_WAY: 80,
  //   DRIVER_ARRIVED: 90,
  //   ON_TRIP: 130,
  //   COMPLETED: 140,
  //   EXPIRED: 75,
  //   CANCELED: 120,
  // };

  public static BOOKING_STATUS_CODES = {
    NEW_REQUEST: 10,
    ADMIN_CONFIRMED: 25,
    DRIVER_ASSIGNED: 40,
    DRIVER_CONFIRMED: 43,
    DRIVER_STATUS_45: 45,
    DRIVER_RECONFIRM: 47,
    DRIVER_ON_THE_WAY: 80,
    DRIVER_ARRIVED: 90,
    ON_TRIP: 130,
    COMPLETED: 140,
    EXPIRED: 75,
    CANCELED: 120,
  };

  public static DRIVER_ASSIGN_CONDITIONS_edit = [
    AppSettings.BOOKING_STATUS_CODES.ADMIN_CONFIRMED,
    // AppSettings.BOOKING_STATUS_CODES.DRIVER_ASSIGNED,
    // AppSettings.BOOKING_STATUS_CODES.DRIVER_CONFIRMED,

    // AppSettings.BOOKING_STATUS_CODES.DRIVER_RECONFIRM,
    // AppSettings.BOOKING_STATUS_CODES.DRIVER_ON_THE_WAY,
    // AppSettings.BOOKING_STATUS_CODES.DRIVER_ARRIVED,
    // AppSettings.BOOKING_STATUS_CODES.ON_TRIP,
  ];
  public static DRIVER_ASSIGN_CONDITIONS = [
    AppSettings.BOOKING_STATUS_CODES.ADMIN_CONFIRMED,
    AppSettings.BOOKING_STATUS_CODES.DRIVER_ASSIGNED,
    AppSettings.BOOKING_STATUS_CODES.DRIVER_CONFIRMED,

    AppSettings.BOOKING_STATUS_CODES.DRIVER_RECONFIRM,
    AppSettings.BOOKING_STATUS_CODES.DRIVER_ON_THE_WAY,
    AppSettings.BOOKING_STATUS_CODES.DRIVER_ARRIVED,
    AppSettings.BOOKING_STATUS_CODES.ON_TRIP,
  ];

  // test line added to check

  // used in AELTC
  // public static BOOKING_STATUS_CODES_OPTIONS = [
  //   { label: 'New Request', value: 10, disabled: true },
  //   { label: 'Admin Confirmed', value: 25 },
  //   { label: 'Driver Assigned', value: 40, disabled: true },
  //   { label: 'Acknowledged', value: 43 },
  //   // { label: 'Driver Reconfirm', value: 45, disabled: true },
  //   { label: 'Reconfirmed', value: 47 },
  //   { label: 'Driver On The Way', value: 80 },
  //   { label: 'Driver Arrived', value: 90 },
  //   { label: 'On Trip', value: 130 },
  //   { label: 'Completed', value: 140 },
  //   { label: 'Expired', value: 75, disabled: true },
  //   { label: 'Cancelled', value: 120 },
  // ];

  // us open usefull
  public static BOOKING_STATUS_CODES_OPTIONS = [
    { label: 'New Request', value: 10 },
    { label: 'Admin Confirmed', value: 25 },
    // { label: 'Driver Assigned', value: 40, disabled: true },
    { label: 'Driver Assigned', value: 43, disabled: true }, // prevouusly Acknowledge
    // { label: 'Driver Reconfirm', value: 45, disabled: true },
    { label: 'Acknowledged', value: 47 }, // prevouusly reconfirmed
    { label: 'Driver On The Way', value: 80 },
    { label: 'Driver Arrived', value: 90 },
    { label: 'On Trip', value: 130 },
    { label: 'Completed', value: 140 },
    { label: 'Expired', value: 75, disabled: true },
    { label: 'Cancelled', value: 120 },
  ];

  public static BOOKING_STATUS_CODES_FILTER_OPTIONS = [
    // { label: 'All', value: '' },
    { label: 'New Request', value: 10 },
    { label: 'Admin Confirmed', value: 25 },
    // { label: 'Driver Assigned', value: 40 },
    { label: 'Driver Assigned', value: 43 }, // prevouusly Acknowledge
    // { label: 'Driver Reconfirm', value: 45 },
    { label: 'Acknowledged', value: 47 }, // prevouusly reconfirmed
    { label: 'Driver On The Way', value: 80 },
    { label: 'Driver Arrived', value: 90 },
    { label: 'On Trip', value: 130 },
  ];

  public static THIRD_PARTY_BOOKING_STATUS_CODES_OPTIONS = [
    { label: 'Admin Confirmed', value: 25, disabled: false },
    { label: 'Acknowledged', value: 47, disabled: false },
    { label: 'Completed', value: 140, disabled: false },
    { label: 'Cancelled', value: 120, disabled: false },
  ];

  // USED FOR HISTORY
  public static BOOKING_HISTORY_STATUS_CODES_FILTER_OPTIONS = [
    { label: 'Completed', value: 140 },
    { label: 'Expired', value: 75 },
    { label: 'Cancelled', value: 120 },
    { label: 'No Show', value: 1204 },
  ];

  // USED FOR SUMMARY REPORTS 
  public static BOOKING_STATUS_CODES_FILTER_OPTIONS_SUMMARY_REPORT = [
    // { label: 'All', value: '' },
    { label: 'New Request', value: 10 },
    { label: 'Admin Confirmed', value: 25 },
    // { label: 'Driver Assigned', value: 40 },
    // { label: 'Acknowledged', value: 43 },
    { label: 'Driver Assigned', value: 43 },

    // { label: 'Driver Reconfirm', value: 45 },
    // { label: 'Reconfirmed', value: 47 },
    { label: 'Acknowledged', value: 47 },
    { label: 'Driver On The Way', value: 80 },
    { label: 'Driver Arrived', value: 90 },
    { label: 'On Trip', value: 130 },
    { label: 'Completed', value: 140 },
    { label: 'Expired', value: 75 },
    { label: 'Cancelled', value: 120 },
  ];

  // USED ON BOOKING DETAILS & ON FILTER
  public static JOURNEY_TYPES_TO_SHOW = [
    { label: 'Passenger', value: 'GENERAL' },
    { label: 'Vehicle Transfer', value: 'VEHICLE_TRANSFER' },
    { label: 'Group Booking', value: 'SHUTTLE' },
    { label: 'Special Event', value: 'SPECIAL_EVENT' },
    { label: 'Third Party', value: 'THIRD_PARTY' },
    { label: 'Shuttle Booking', value: 'SHUTTLE_BOOKING' },
  ];

  // USED ON BOOKING DETAILS & ON FILTER
  public static JOURNEY_TYPES_OF_TAB = [
    { label: 'Inbound', value: 'INBOUND' },
    { label: 'Outbound', value: 'OUTBOUND' },
    { label: 'Other', value: 'OTHER' },
    { label: 'Vehicle Transfer', value: 'VEHICLE_TRANSFER' },
    { label: 'Special Request', value: 'LUGGAGEBOOKINGS' },
  ];

  // bookingHistory list page
  public static HISTORY_JOURNEY_TYPES = [
    { label: 'Passenger', value: 'GENERAL' },
    { label: 'Vehicle Transfer', value: 'VEHICLE_TRANSFER' },
    // { label: 'Shuttle', value: 'SHUTTLE' },
    // { label: 'Special Event', value: 'SPECIAL_EVENT' },
    // { label: 'Third Party', value: 'THIRD_PARTY' },
  ];

  public static EMERGENCY_STATUS_CODES_OPTIONS = [
    { label: 'New', value: 1 },
    { label: 'Attended', value: 2 },
    { label: 'Closed', value: 3 },
  ];

  public static EMERGENCY_STATUS_CODES_OPTIONS1 = [
    { label: 'New', value: 'NEW' },
    { label: 'Attended', value: 'ATTENDED' },
    { label: 'Closed', value: 'CLOSED' },
  ];

  public static EMERGENCY_STATUS_CODES_FILTER_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'New', value: 1 },
    { label: 'Attended', value: 2 },
    { label: 'Closed', value: 3 },
  ];

  public static EMERGENCY_USER_TYPES_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'Passenger', value: 'Passenger' },
    { label: 'Driver', value: 'Driver' },
  ];

  public static SHIFT_STATUS_OPTIONS = [
    { label: 'ALL', value: 'ALL' },
    { label: 'ON', value: 'ON' },
    { label: 'OFF', value: 'OFF' },
  ];

  public static DRIVER_TYPE_OPTIONS = [
    { label: 'ALL', value: 'all' },
    { label: 'Available', value: 'available' },
    { label: 'Busy', value: 'busy' },
    // { label: 'check-In', value: 'checkedin' },
  ];

  public static SHIFT_STATUS_FILTER_OPTIONS = [
    { label: 'ALL', value: '' },
    { label: 'ON', value: 'ON' },
    { label: 'OFF', value: 'OFF' },
  ];
  public static DRIVER_ASSIGN_SORT_KEYS = [
    'idleTime',
    'nearby'
  ];

  public static CURRENT_DRIVER_STATUS = [
    { label: 'All', value: '' },
    { label: 'On Shift', value: 'on_shift' },
    { label: 'Busy', value: 'busy' },
    { label: 'Available', value: 'available' }
  ];

  public static RADIUS_LIST = [
    { label: '1 Mile', value: '1' },
    { label: '2 Miles', value: '2' },
    { label: '3 Miles', value: '3' },
    { label: '4 Miles', value: '4' },
    { label: '5 Miles', value: '5' },
    { label: '6 Miles', value: '6' },
    { label: '7 Miles', value: '7' },
    { label: '8 Miles', value: '8' },
    { label: '9 Miles', value: '9' },
    { label: '10 Miles', value: '10' },
    { label: '20 Miles', value: '20' },
    { label: '30 Miles', value: '30' },
    { label: '40 Miles', value: '40' },
    { label: '50 Miles', value: '50' },
    { label: '60 Miles', value: '60' },
    { label: '70 Miles', value: '70' },
    { label: '80 Miles', value: '80' },
    { label: '90 Miles', value: '90' },
    { label: '100 Miles', value: '100' }
  ];
  
  public static DRIVER_ASSIGN_SORT = [
    { label: 'Idle Time', value: 'idle_time' },
    { label: 'Pickup Time', value: 'pickup_time' },
    { label: 'Distance', value: 'distance' }
  ];

  public static LOCATION_CATEGORY_OPTIONS = [
    { label: 'QUEUE', value: 'locCatId00002' },
    { label: 'PARKING', value: 'locCatId00001' },
  ];
  public static PARKING_LOCATION_ID = 'locCatId00001';
  public static MAX_PWC_COUNT = 100;

  public static EDIT_BOOKING_AVAILABLE_ON = [
    AppSettings.BOOKING_STATUS_CODES.NEW_REQUEST,
    AppSettings.BOOKING_STATUS_CODES.ADMIN_CONFIRMED,
    AppSettings.BOOKING_STATUS_CODES.DRIVER_ASSIGNED,
    AppSettings.BOOKING_STATUS_CODES.DRIVER_CONFIRMED,
    AppSettings.BOOKING_STATUS_CODES.DRIVER_STATUS_45,
    AppSettings.BOOKING_STATUS_CODES.DRIVER_RECONFIRM,
  ];


  public static UNIQID = {
    ADMIN_DASHBO_EMERGE_F173: 'admin-dashboard-emergency-f17394',
    ADMIN_DASHBO_EMERGE_502E: 'admin-dashboard-emergency-502e96',
    BOOKIN_LOAD_REPORT_A5CE: 'bookings-load-report-a5ce66',
    BOOKIN_BOOKIN_HISTOR_41AA: 'bookings-booking-history-41aab0',
    BOOKIN_BOOKIN_BOOKIN_D281: 'bookings-bookings-view-d281aa',
    BOOKIN_FLIGHT_DETAIL_E8B9: 'bookings-flight-details-e8b9df',
    BOOKIN_LOAD_BOOKIN_4A18: 'bookings-load-bookings-4a1807',
    CORPOR_BOOKIN_LIST_84DD: 'corporate-bookings-list-84dd92',
    CORPOR_CHARGE_CODE_C1FA: 'corporate-charge-code-c1fada',
    CORPOR_MANAGE_LIST_4D21: 'corporate-manage-list-4d2154',
    CORPOR_MANAGE_HISTOR_CC18: 'corporate-manage-history-cc18de',
    CORPOR_MANAGE_LIST_1A77: 'corporate-manage-list-1a7704',
    CORPOR_PASSEN_LIST_719B: 'corporate-passenger-list-719b0d',
    CORPOR_PENDIN_HISTOR_4E65: 'corporate-pending-history-4e6573',
    CORPOR_PENDIN_LIST_E6B6: 'corporate-pending-list-e6b6af',
    CORPOR_PRICIN_DETAIL_B38E: 'corporate-pricing-details-b38e64',
    CORPOR_PRICIN_DEATIL_3CBF: 'corporate-pricing-deatils-3cbfb2',
    CORPOR_CORPOR_PACKAG_F591: 'corporates-corporate-package-f59111',
    CORPOR_CORPOR_PRICIN_62CB: 'corporates-corporate-pricing-62cb38',
    CORPOR_HISTOR_CORPOR_DB6C: 'corporates-history-corporates-db6c66',
    CORPOR_LIST_CORPOR_FA38: 'corporates-list-corporates-fa384c',
    DISPAT_DISPAT_HISTOR_1C1E: 'dispatchers-dispatcher-history-1c1e9c',
    DISPAT_LIST_DISPAT_89FC: 'dispatchers-list-dispatchers-89fc36',
    DRIVER_TIME_LIST_3F6D: 'driver-time-list-3f6db5',
    DRIVER_TIME_PERIOD_7A79: 'driver-time-periods-7a793e',
    DRIVER_TIME_GLOBAL_0E39: 'driver-time-global-0e39d0',
    DRIVER_HISTOR_DRIVER_943B: 'drivers-history-drivers-943b7c',
    DRIVER_DRIVER_DASHBO_C995: 'drivers-driver-dashboard-c995ee',
    DRIVER_LIST_DRIVER_9834: 'drivers-list-drivers-9834d6',
    EMERGE_LIST_EMERGE_E672: 'emergency-list-emergency-e67235',
    EVENT_LIST_EVENT_D2DF: 'event-list-event-d2df75',
    HELPS_DOCUME_LIST_BFCA: 'helps-document-list-bfca89',
    HOTEL_BOOKIN_BOOKIN_28D9: 'hotel-booking-bookings-28d932',
    HOTELS_EDITAB_DETAIL_A35F: 'hotels-editable-details-a35fb5',
    HOTELS_EDITAB_PRICIN_0EFA: 'hotels-editable-pricing-0efab7',
    HOTELS_HISTOR_HOTELS_F712: 'hotels-history-hotels-f7125e',
    HOTELS_LIST_HOTELS_4779: 'hotels-list-hotels-47796f',
    INCIDE_COMPLA_LIST_594F: 'incidents-complaints-list-594f5a',
    MANAGE_CITIES_RIDES_C24D: 'manage-cities-rides-c24d5d',
    MANAGE_CITIES_PRICIN_B3FA: 'manage-cities-pricing-b3fa58',
    MANAGE_CITIES_PRICIN_878A: 'manage-cities-pricing-878aa4',
    MANAGE_CITIES_GRID_8EEE: 'manage-cities-grid-8eee9e',
    MANAGE_CITIES_CITIES_D15A: 'manage-cities-cities-d15a2a',
    MANAGE_CITIES_REGION_30D2: 'manage-cities-regions-30d259',
    MANAGE_COMPAN_LIST_1002: 'manage-companies-list-1002ea',
    MANAGE_LOCATI_LIST_30E6: 'manage-locations-list-30e60e',
    MANAGE_SHUTTL_SIDEBA_F797: 'manage-shuttles-sidebar-f79758',
    MANAGE_SHUTTL_TOURS_0F91: 'manage-shuttles-tours-0f911f',
    MANAGE_SHUTTL_VIEW_4B1B: 'manage-shuttles-view-4b1b92',
    MANAGE_SHUTTL_LIST_22AE: 'manage-shuttles-list-22aeb7',
    MANAGE_SHUTTL_LIST_69AF: 'manage-shuttles-list-69af41',
    MANAGE_SHUTTL_LIST_16A9: 'manage-shuttles-list-16a9e0',
    MANAGE_SHUTTL_LIST_314C: 'manage-shuttles-list-314c37',
    MANAGE_SHUTTL_LIST_15CA: 'manage-shuttles-list-15cabb',
    MANAGE_SHUTTL_LIST_0F81: 'manage-shuttles-list-0f81ee',
    MANAGE_SHUTTL_LIST_383C: 'manage-shuttles-list-383cc9',
    MANAGE_SHUTTL_LIST_1A16: 'manage-shuttles-list-1a16f2',
    MANAGE_SHUTTL_LIST_47D9: 'manage-shuttles-list-47d92a',
    MARKET_SEGMEN_DETAIL_C3D6: 'marketing-segment-details-c3d649',
    MARKET_NOTIFI_LIST_FC69: 'marketing-notification-list-fc69ad',
    MARKET_PROMO_CODE_BDBA: 'marketing-promo-code-bdba63',
    MARKET_SEGMEN_SEGMEN_363E: 'marketing-segment-segment-363e99',
    OCCASI_TRIP_LIST_D221: 'occasional-trip-list-d22197',
    OPERAT_MANAGE_OPERAT_5645: 'operator-management-operators-5645df',
    OPERAT_MANAGE_ROLES_423C: 'operator-management-roles-423c4f',
    PASSEN_PASSEN_HISTOR_B02D: 'passengers-passenger-history-b02d6e',
    PASSEN_SET_ADDRES_7047: 'passengers-set-addresses-704729',
    PASSEN_PASSEN_DETAIL_9A21: 'passengers-passenger-details-9a21f8',
    PASSEN_LIST_PASSEN_BFE1: 'passengers-list-passengers-bfe179',
    QUEUE_MANAGE_QUEUE_ACFE: 'queue-management-queue-acfea5',
    QUEUE_MANAGE_LIST_436E: 'queue-management-list-436e41',
    REPORT_BOOKIN_REPORT_3D60: 'reports-bookin-report-3d6077',
    REPORT_CAR_MILEAG_BA78: 'reports-car-mileage-ba78a1',
    REPORT_CAR_DETAIL_9AA0: 'reports-car-details-9aa041',
    REPORT_CHARGE_DETAIL_9D4F: 'reports-charge-details-9d4ffe',
    REPORT_CHARGE_REPORT_5C2B: 'reports-charge-report-5c2bbf',
    REPORT_COMPAN_INCOME_B920: 'reports-company-income-b9206a',
    REPORT_CORPOR_REPORT_323D: 'reports-corporate-report-323d2c',
    REPORT_CORPOR_REPORT_3731: 'reports-corporate-report-37314a',
    REPORT_DRIVER_REPORT_22F2: 'reports-driver-report-22f203',
    REPORT_DRIVER_LIST_27EE: 'reports-driver-list-27ee03',
    REPORT_DRIVER_CHECKI_C41D: 'reports-driver-checkins-c41d9e',
    REPORT_DRIVER_LIST_5B89: 'reports-driver-list-5b891f',
    REPORT_DRIVER_DUTY_0D8A: 'reports-driver-duty-0d8a9d',
    REPORT_DRIVER_DETAIL_6B90: 'reports-driver-details-6b90a8',
    REPORT_DRIVER_REPORT_7AFB: 'reports-driver-report-7afbd5',
    REPORT_DRIVER_FEEDBA_47CE: 'reports-driver-feedback-47ce41',
    REPORT_DRIVER_DETAIL_422A: 'reports-driver-details-422a5c',
    REPORT_DRIVER_STATUS_6E5E: 'reports-driver-status-6e5e74',
    REPORT_DRIVER_LOGOUT_0B37: 'reports-driver-logout-0b37ba',
    REPORT_DRIVER_DETAIL_F511: 'reports-driver-details-f51155',
    REPORT_DRIVER_MILEAG_4F8A: 'reports-driver-mileage-4f8a70',
    REPORT_DRIVER_DETAIL_AEFA: 'reports-driver-details-aefae6',
    REPORT_DRIVER_PERFOR_6457: 'reports-driver-performance-64572c',
    REPORT_DRIVER_REPORT_3ED2: 'reports-driver-reports-3ed2c9',
    REPORT_DRIVER_VIEW_523B: 'reports-driver-view-523bad',
    REPORT_INBOUN_LIST_7E5D: 'reports-inbound-list-7e5d56',
    REPORT_PASSEN_REPORT_F798: 'reports-passenger-report-f798ac',
    REPORT_PASSEN_REPORT_FE01: 'reports-passenger-report-fe01d9',
    REPORT_PASSEN_FEEDBA_6D2A: 'reports-passenger-feedback-6d2a1a',
    REPORT_PASSEN_DETAIL_8704: 'reports-passenger-details-8704dc',
    REPORT_PASSEN_REPORT_58EA: 'reports-passenger-report-58eab9',
    REPORT_PASSEN_REPORT_03BA: 'reports-passenger-report-03ba26',
    REPORT_PASSEN_REPORT_1023: 'reports-passenger-report-1023ed',
    REPORT_PROMO_DETAIL_A94D: 'reports-promo-details-a94d03',
    REPORT_PROMO_REPORT_5A77: 'reports-promo-report-5a774c',
    REPORT_REFERR_CREDIT_0BCA: 'reports-referral-credit-0bca3f',
    REPORT_REFERR_DETAIL_CDD2: 'reports-referral-details-cdd238',
    REPORT_REFUND_REFUND_807A: 'reports-refund-refund-807a75',
    REPORT_REFUND_REPORT_500B: 'reports-refund-reports-500b27',
    REPORT_SHIFT_REPORT_37E0: 'reports-shift-report-37e094',
    REPORT_TRANSA_TRANSA_C54F: 'reports-transaction-transaction-c54fb6',
    REPORT_TRANSA_DETAIL_07EB: 'reports-transaction-details-07eb57',
    REPORT_USER_REPORT_7603: 'reports-user-report-76036a',
    REPORT_MODULE_STATIS_870A: 'reports-module-statistics-870a4a',
    SALES_QUOTAT_LIST_2468: 'sales-quotation-list-246826',
    SETTIN_OCCASI_RIDE_39DC: 'settings-occasional-ride-39dca0',
    SETTIN_PRICIN_DETAIL_B7B7: 'settings-pricing-detail-b7b777',
    SETTIN_RENTAL_PRICIN_6416: 'settings-rental-pricing-641610',
    SETTIN_TAXI_PRICIN_0F2C: 'settings-taxi-pricing-0f2c98',
    SETTIN_TIME_LOGS_267E: 'settings-time-logs-267e4e',
    SETTIN_MANAGE_TAXES_506E: 'settings-manage-taxes-506e3e',
    SETTIN_PRICIN_PRICIN_F9E4: 'settings-pricing-pricing-f9e4e8',
    SETTIN_VEHICL_GROUP_384E: 'settings-vehicle-group-384e3f',
    SETTIN_VEHICL_TYPE_B97F: 'settings-vehicle-type-b97fa8',
    SHARED_LOG_DEAILS_5200: 'shared-log-deails-5200ec',
    SHARED_MERGE_POPUP_3716: 'shared-merge-popup-3716fe',
    SHARED_PASSEN_BOOKIN_5ADB: 'shared-passenger-bookings-5adb40',
    SHARED_RECENT_REQUES_B06C: 'shared-recent-request-b06c97',
    SHARED_ALL_BOOKIN_0B88: 'shared-all-bookings-0b88c3',
    SHARED_BOOKIN_LIST_5342: 'shared-bookings-list-5342f9',
    SHARED_CRITIC_JOURNE_694D: 'shared-critical-journey-694d32',
    SHARED_INBOUN_JOURNE_5C6A: 'shared-inbound-journey-5c6af0',
    SHARED_LUGGAG_REQUES_03AA: 'shared-luggage-request-03aa74',
    SHARED_MERGE_BOOKIN_1227: 'shared-merge-bookings-122788',
    SHARED_OTHER_JOURNE_C43A: 'shared-other-journey-c43ae6',
    SHARED_OUTBOU_JOURNE_FD2B: 'shared-outbound-journey-fd2b3a',
    SHARED_THIRD_TRANSF_8067: 'shared-third-transfer-8067ea',
    SHARED_VEHICL_TRANSF_5FE8: 'shared-vehicle-transfer-5fe8c1',
    SHARED_SIDEBA_DRIVER_52A4: 'shared-sidebar-driver-52a4f8',
    SHIFT_MANAGE_LIST_1081: 'shift-management-list-1081f8',
    STAFF_TRANSP_LIST_0CCC: 'staff-transport-list-0cccde',
    USER_MANAGE_ROLES_D771: 'user-management-roles-d7717a',
    USER_MANAGE_USERS_C0E2: 'user-management-users-c0e264',
    USER_MANUAL_LIST_2872: 'user-manual-list-2872a3',
    VEHICL_HISTOR_VEHICL_952D: 'vehicles-history-vehicles-952d88',
    VEHICL_LIST_VEHICL_C3C2: 'vehicles-list-vehicles-c3c2e3',
  };

  public static MI_FILTER_TYPE = {
    SINGLE_SELECT: 'single',
    MULTI_SELECT: 'multi',
    DATE: 'date',
    DATE_RANGE: 'date_range',
  };

  public static FILTER_SCREEN_CODE = {
    INBOUND_OTHER_SCREEN: 'inbound_and_other_bookings_screen',
    ALL_SCREEN: 'all_screen',
    BOOKING_ASSIGN_DRIVER: "booking_assign_driver",
    INBOUND_SCREEN: 'inbound_screen',
    OUTBOUND_SCREEN: 'outbound_screen',
    CRITICAL_SCREEN: 'critical_screen',
    OTHER_SCREEN: 'other_journey_screen',
    VEHICLE_TRANSFER_SCREEN: 'vehicle_transfer_screen',
    THIRD_PARTY_TRANSFER_SCREEN: 'third_party_transfer_screen',
    DEDICATED_SCREEN: 'dedicated_screen',
    BOOKING_HISTORY_SCREEN: 'booking_history_screen',
    FLIGHT_BOOKINGS_SCREEN: 'flight_bookings_screen',
    EMERGENCY_SCREEN: 'emergency_screen',
    SHIFT_GROUPS_SCREEN: 'shift_groups_screen',
    DRIVERS_SCREEN: 'drivers_screen',
    DRIVER_DASHBOARD_SCREEN: 'driver_dashboard_screen',
    PASSENGERS_SCREEN: 'passengers_screen',
    USERS_SCREEN: 'users_screen',
    SUPPORT_MANAGEMENT_SCREEN : 'support_numbers_management',

    VEHICLES_SCREEN: 'vehicles_screen',
    EVENT_SCREEN: 'manage_events',
    INCIDENT_COMPLAINT_SCREEN: 'manage_incidents_complaints',
    LOCATIONS_SCREEN: 'locations_screen',
    PASSENGER_TYPES_SCREEN: 'passenger_types_screen',
    OUTBOUND_QUEUE_SCREEN: 'manage_queue_drivers_screen',
    ADD_DRIVER_IN_QUEUE_SCREEN: 'add_drivers_in_queue_screen',
    DRIVER_LOGS_FROM_TO_DATE_SCREEN: 'driver_activity_logs_screen',
    PASSENGER_LOGS_FROM_TO_DATE_SCREEN: 'passenger_activity_logs_screen',
    VEHICLE_LOGS_FROM_TO_DATE_SCREEN: 'vehicle_activity_logs_screen',
    REPORT_DRIVER_LOGIN_LOGOUT_DETAILS_SCREEN: 'report_driver_login_logout_details_screen',
    REPORT_DRIVER_ON_DUTY_DETAILS_SCREEN: 'report_driver_on_duty_details_screen',
    REPORT_DRIVER_PERFORMANCE_DETAILS_SCREEN: 'report_driver_performance_details_screen',
    REPORT_CAR_MILEAGE_DETAILS_SCREEN: 'report_car_mileage_details_screen',
    REPORT_PASSENGER_FEEDBACK_DETAILS_SCREEN: 'report_passenger_feedback_details_screen',
    REPORT_PASSENGER_BOOKING_DETAILS_SCREEN: 'report_passenger_bookings_details_screen',
    REPORT_PASSENGER_FEEDBACK_SCREEN: 'report_passenger_feedback_screen',
    REPORT_PASSENGER_BOOKING_SCREEN: 'report_passenger_bookings_screen',
    CRITICAL_SCREEN_OPEN_CLOSE_FILTER_PERSIST: 'openCloseCritacalFilter',
    REPORT_DRIVER_CHECKIN_SCREEN: 'report_driver_checkin_screen',
    REPORT_DRIVER_DUTY_STATUS_SCREEN: 'report_driver_duty_status_screen',
    REPORT_SHIFT_STATUS_SCREEN: 'report_shift_status_screen',
    REPORT_BOOKING_SUMMARY_SCREEN: 'report_booking_summary_screen',
    SHUTTLES_LIST_SCREEN: 'shuttle_list_screen',
    SHUTTLE_DRIVER_LIST_SCREEN: 'shuttle_driver_list_screen',
    SHUTTLE_ROUTES_SCREEN: 'shuttle_routes_screen',
    SHUTTLE_SCHEDULES_SCREEN: 'shuttle_schedules_screen',
    SHUTTLE_TOURS_LIST_SCREEN: 'shuttle_tours_list_screen',
    SHUTTLE_BOOKINGS_SCREEN: 'shuttle_bookings_screen',
    SHUTTLE_ASSIGN_SCHEDULE_SCREEN: 'shuttle_assign_schedule_screen',
    REPORT_MODULE_WISE_STATISTICS_SCREEN: "report_module_wise_statistics_screen",
    TIME_SETTINGS_ACTIVITY_LOG_SCREEN_CODE: 'time_settings_activity_log_screen',
    LOAD_BOOKINGS_SCREEN: "assign_drivers_screen",
    REPORT_DRIVER_LOGIN_DUTY_STATUS_SCREEN_CODE:'report_driver_login_duty_status_screen',
    MERGE_BOOKINGS: 'merge_bookings',
    DRIVER_SCHEDULE_SCREEN: "driver_schedule_screen",
    DRIVER_REST_PERIOD_SCREEN: 'drivers_rest_period_details_screen',
    VEHICLES_SCHEDULE_SCREEN: 'vehicles_schedule_screen',
        DRIVER_SCHEDULE: "driver_schedule_screen",
    BULK_IMPORT_PASSENGER_SCREEN: 'bulk_import_passenger_screen',
    BULK_IMPORT_GROUP_SCREEN: 'bulk_import_group_screen',
    BULK_IMPORT_VEHICLE_TRANSFER_SCREEN: 'bulk_import_vehicle_transfer_screen',
    BULK_IMPORT_SHUTTLE_SCREEN: 'bulk_import_shuttle_screen',
    DASHBOARD_SCREEN: 'dashboard_screen',
    DEDICATED_GRID_SCREEN: 'dedicated_grid_screen',
    SEGMENT_SCREEN: 'segments_screen',
    PASSENGER_BOOKING_REPORT_SCREEN: 'report_passenger_bookings_screen',
    DRIVER_LOGIN_LOGOUT_REPORT_SCREEN:'report_driver_login_logout_details_screen',
    DRIVER_PERFORMANCE_REPORT_SCREEN:'report_driver_performance_screen',
    MANAGE_TEAMS_SCREEN: 'teams_screen',
    ASSIGN_DRIVER_SCREEN_GRID_VIEW: 'assign_driver_screen_grid_view',
    ASSIGN_DRIVER_SCREEN_MAP_VIEW: 'assign_driver_screen_map_view'
  };

  public static BOOKING_SORT_BY_TIME_OPTIONS = [
    // s{ label: '', value: '' },
    { label: 'Pickup Time Ascending', value: 'pickup_time_acsending' },
    { label: 'Pickup Time Descending', value: 'pickup_time_descending' },
    { label: 'Drop Off ETA', value: 'eta' }
  ];

  public static BOOKING_SORT_BY_TIME_OPTIONS_OUTBOUND = [
    { label: 'Pickup Time Ascending', value: 'pickup_time_acsending' },
    { label: 'Pickup Time Descending', value: 'pickup_time_descending' },
    { label: 'Drop Off ETA', value: 'eta' },
    { label: 'Departure Time', value: 'default' }
  ];

  public static ETA_TIME_OPTIONS = [
    { label: 'Select', value: 0 },
    { label: '15 Min', value: 900000 },
    { label: '30 Min', value: 1800000 },
    { label: '45 Min', value: 2700000 },
    { label: '60 Min', value: 3600000 },
    { label: '75 Min', value: 4500000 },
    { label: '90 Min', value: 5400000 },
    { label: '105 Min', value: 6300000 },
    { label: '120 Min', value: 7200000 }
  ];


  public static OPEN_CLOSE_FILTERS = {
    OPEN_CLOSE_INBOUND_FILTER: 'openCloseInboundFilter',
    OPEN_CLOSE_CRITICAL_FILTER: 'openCloseCritacalFilter',
    OPEN_CLOSE_OUTBOUND_FILTER: 'openCloseOutboundFilter',
    OPEN_CLOSE_VEHICLE_TRANSFER_FILTER: 'openCloseVehicleTransferFilter',
    OPEN_CLOSE_THIRD_PARTY_FILTER: 'openCloseThirdPartyFilter',
  };

  public static PRIORITY_OPTIONS = [
    { priority: 'VIP', inboundStartTime: 0, inboundEndTime: 0, outboundStartTime: 0, outboundEndTime: 0 },
    { priority: '1', inboundStartTime: 0, inboundEndTime: 0, outboundStartTime: 0, outboundEndTime: 0 },
    { priority: '2', inboundStartTime: 0, inboundEndTime: 0, outboundStartTime: 0, outboundEndTime: 0 },
    { priority: '3', inboundStartTime: 0, inboundEndTime: 0, outboundStartTime: 0, outboundEndTime: 0 },
    { priority: '4', inboundStartTime: 0, inboundEndTime: 0, outboundStartTime: 0, outboundEndTime: 0 },
  ];

  //vehicle types for add assign driver screen 
  public static VEHICLE_TYPE_IDS = {
    SUV: 'vehicleType0001',
    SPRINTER: 'vehicleType0002',
    SEDAN: 'vehicleType0003'
  };

  public static PREFFERED_FOR_USER_TYPE_OPTIONS = [
    { label: 'All', value: 'ALL' },
    { label: 'Player and Coach', value: 'PLAYER_COACH' },
    { label: 'Non Player and Coach', value: 'NON_PLAYER_COACH' },
  ];

  public static AMENITIES_LIST = [
    {
      "id": "1",
      "busId": 0,
      "busAmenityTypeId": 0,
      "amenityName": "Charging Point",
      "activeFile": "assets/images/temp/charging_point_active.svg",
      "inactiveFile": "assets/images/temp/charging_point_deactive.svg",
      "isActive": false,
    },
    {
      "id": "2",
      "busId": 0,
      "busAmenityTypeId": 0,
      "amenityName": "Fridge",
      "activeFile": "assets/images/temp/fridge_active.svg",
      "inactiveFile": "assets/images/temp/fridge_deactive.svg",
      "isActive": false,
    },
    {
      "id": "3",
      "busId": 0,
      "busAmenityTypeId": 0,
      "amenityName": "Toilet",
      "activeFile": "assets/images/temp/toilet_active.svg",
      "inactiveFile": "assets/images/temp/toilet_deactive.svg",
      "isActive": false,
    },
    {
      "id": "4",
      "busId": 0,
      "busAmenityTypeId": 0,
      "amenityName": "Wheel Chair",
      "activeFile": "assets/images/temp/wheel_chair_active.svg",
      "inactiveFile": "assets/images/temp/wheel_chair_deactive.svg",
      "isActive": false,
    }
  ];
  static SCHEDULE_LIST_KEY = 'schedules_list';
  static DESTINATION_POINT_KEY = 'destinations';
  static SHUTTLE_VEHICLE_TYPE_ID = 'vehicleType0002';
  static VEHICLE_CONDITION = '3';
  static SHUTTLE_OWNERSHIPID = '2';
  static BUS_TYPE_ID = '3';
  static HAS_AC = 'yes';
  static SAMPLE_SCHEDULE_FILE = '4726a62d69424e7cae55a04593d6c7e8.xlsx';
  static SCREEN_CODE_SHUTTLE_SCHEDULE = 'shuttle_schedules';
  static SCREEN_CODE_SHUTTLE_SCHEDULE_UPDATE = 'shuttle_schedules_update';


  static SHUTTLE_STATUS_FILTER = [
    { label: 'All', value: '' },
    { label: 'Activated', value: 'true' },
    { label: 'Deactivated', value: 'false' }
  ];

  static SHUTTLE_TOUR_STATUS_FILTER = [
    { label: 'All', value: '' },
    { label: 'New', value: 'New' },
    { label: 'Started', value: 'Started' },
    { label: 'Cancelled', value: 'Cancelled' },
    { label: 'Expired', value: 'Expired' },
    { label: 'Ended', value: 'Ended' }
  ];

  public static TRANSPORT_MODE = [
    { label: 'Car Service', value: 'car_service' },
    { label: 'Shuttle Service', value: 'shuttle_service' }
  ];

  public static TRANSPORT_MODE_ALL = [
    { label: 'All', value: 'all' },
    { label: 'Car Service', value: 'car_service' },
    { label: 'Shuttle Service', value: 'shuttle_service' }
  ];

  public static TRANSPORT_MODE_CAR_SERVICE = 'car_service';
  public static TRANSPORT_MODE_SHUTTLE_SERVICE = 'shuttle_service';
  static BOOKING_SORT_BY_OPTIONS: any;

   //Google Route
   public static strokeColor = "#0094ff";
   public static strokeOpacity = 1.0;
   public static strokeWeight = 4;

   public static DEFAULT_TIMEZONE = 'default_timezone';

  public static ACTIVE_DEACTIVE_STATUS = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'Active' },
    { label: 'Deactive', value: 'Deactive' }
  ];
 
    public static MAX_INTERMEDIATE_STOPS = 'maximum_intermediate_stops_allowed';
  public static MULTIPLE_STOP = 'Multiple Stops';
    public static ACTIVATE = 'activate';
  public static DEACTIVATE = 'deactivate';
  public static MULTIPLE_VEHICLE = 'Multiple Vehicles';

   public static ACCESSIBILITY_REQUIREMENTS_LIST = [
    {
      "id": "bstg3j96wyegdfsb764gdnn350ch0001",
      "tenantId": "T00001",
      "accessibilityName": "Wheelchair - Transferrable",
      "accessibilityDescription": "Wheelchair - Transferrable",
      "priority": 1,
      "activated": true
    },
    {
      "id": "bstg3j96wyegdfsb764gdnn350ch0002",
      "tenantId": "T00001",
      "accessibilityName": "Wheelchair - Non-Transferrable",
      "accessibilityDescription": "Wheelchair - Non-Transferrable",
      "priority": 2,
      "activated": true
    },
    {
      "id": "bstg3j96wyegdfsb764gdnn350ch0003",
      "tenantId": "T00001",
      "accessibilityName": "Other",
      "accessibilityDescription": "Other",
      "priority": 3,
      "activated": true
    }
  ];

  public static LANGUAGE_LABELS = {
    'en': 'English',
    'es': 'Spanish',
    'fr': 'French',
    'de': 'German',
    'it': 'Italian',
    'pt': 'Portuguese',
    'ru': 'Russian',
  };

  public static LANGUAGE_CODES = {
    'en': 'en',
    'es': 'es',
    'fr': 'fr',
    'de': 'de',
    'it': 'it',
    'pt': 'pt',
    'ru': 'ru',
  };

  public static LANGUAGE_OPTIONS = [
    { label: 'English', value: 'en' },
    { label: 'Italian', value: 'it' },
    { label: 'French', value: 'fr' },
  ];

  public static NO_SHOW = 'no_show';

  public static NO_SHOW_TYPE = {
    NO_SHOW: 'NOSHOW',
    CANCEL: 'CANCEL'
  }

  public static APP_TYPE = 'admin';

  public static FLAGS = {
    IS_OFFLINE_TAB_APPLICABLE: 'send_driver_location_when_off_duty'
  }

  // Branding changes
  public static logoPath = '/assets/images/TMS/logo.png';
  // public static logoPath = '/assets/images/MI/header-logo.svg';
  // public static logoPath = '/assets/images/IIHF/header-logo.svg';

  // Branding changes
  // public static LOGIN_LOGO = '/assets/images/MI/header-logo.svg';
  public static LOGIN_LOGO = '/assets/images/TMS/logo.png';
  // public static LOGIN_LOGO = '/assets/images/IIHF/logo.svg';

  public static METHOD_TYPE = {
    GET: 'GET',
    POST: 'POST'
  }

  public static BOOKING_GRID_API_METHOD = AppSettings.METHOD_TYPE.POST;

  public static WATCH_LIST = [
    { label: 'All', value: '' },
    { label: 'Yes', value: 'watchlist' },
    { label: 'No', value: 'non_watchlist' },
  ];

  public static AIRPORT_BOOKING_TYPES = [
    'AIRPORT_PICKUP',
    'AIRPORT_DROPOFF',
    'TRAIN_STATION_PICKUP',
    'TRAIN_STATION_DROPOFF',
  ];

  public static AVAILABLE_FOR_SERVICE_OPTIONS = [
    { label: 'General', value: 'CAR' },
    { label: 'Dedicated', value: 'DEDICATED' },
  ];

  public static TENANT_FLAGS = {
    EXTEND_DEDICATED_BOOKING_DATE: 'dedicated_journey_extension',
  };

  public static DEDICATED_BOOKING_EXTENSION_TYPES = {
    START_DATE: 'EXTENDBEFORE',
    END_DATE: 'EXTENDAFTER',
  };
}